import React, { Fragment, useState, useEffect, useContext } from "react";
import { Modal, Button, Card, CardBody, Col, Container, Row, Input, Form, Label } from "reactstrap";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import Breadcrumb from "../components/common/Breadcrumb";
import { Capitalize } from "../components/common/function/function";
import Dragndrop from "../components/common/DragNDrop";
import { ThemeContext } from "../contexts/ThemeContext";

const DocumentList = () => {
  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [datas, setDatas] = useState([]);
  const [chatMessages, setChatMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [files, setFiles] = useState([]);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you wish to delete this item?")) {
      // dispatch(deluniltList(id))
    }
  };

  const handleFileChange = (event) => {
    setSelectedFiles([...selectedFiles, ...event.target.files]);
    console.log("data",selectedFiles);
  };

  const handleFileUpload = () => {
    console.log("Files uploaded:", selectedFiles);
    setSelectedFiles([]);
  };

  useEffect(() => {
    setDatas([
      { _id: "1", name: "MRR Organization", status: "active" },
      { _id: "2", name: "PNB Organization", status: "active" },
      { _id: "3", name: "NPF Organization", status: "active" },
    ]);
  }, []);

  return (
    <Fragment>
      {/* <Breadcrumb title="Document" parent="Products" /> */}
      {/* <Container fluid> */}
        <Row>
          <Col sm="8" className="remove-pad background-div">
            {/* <Card>
              <CardBody> */}
              <Dragndrop onFilesSelected={setFiles} width="100%" height='auto'/>
              <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
                    {selectedFiles.map((file, index) => (
                      <div key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {file.type.startsWith("image") ? (
                          <img src={URL.createObjectURL(file)} alt={file.name} width="100" height="100" />
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <i className="fa fa-file" style={{ fontSize: "50px" }}></i>
                            <p>{file.name}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                {/* <div style={{ border: "2px dotted", borderRadius: "10px", padding: "10px" }}>
                  <Input type="file" multiple onChange={handleFileChange} />
                  <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
                    {selectedFiles.map((file, index) => (
                      <div key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {file.type.startsWith("image") ? (
                          <img src={URL.createObjectURL(file)} alt={file.name} width="100" height="100" />
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <i className="fa fa-file" style={{ fontSize: "50px" }}></i>
                            <p>{file.name}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <Button color="primary" className="mt-2" onClick={handleFileUpload}>Upload</Button>
                </div> */}
              {/* </CardBody>
            </Card> */}
          </Col>
          <Col sm="4" className="remove-pad">
            <Card className="bg-set">
              <CardBody className="full-height">
                <h5>Chat</h5>
                <div  className="chat-message-box">
                  {chatMessages.map((msg, index) => (
                    <div key={index} style={{ marginBottom: "10px", textAlign: msg.sender === "User" ? "right" : "left" }}>
                      <span style={{ background: msg.sender === "User" ? "#d1e7dd" : "#f8d7da", padding: "5px 10px", borderRadius: "10px", display: "inline-block" }}>
                        {msg.text}
                      </span>
                    </div>
                  ))}
                </div>
                <Form onSubmit={(e) => {
                  e.preventDefault();
                  if (newMessage.trim()) {
                    setChatMessages([...chatMessages, { text: newMessage, sender: "User" }, { text: "Thanks for your message!", sender: "Bot" }]);
                    setNewMessage("");
                  }
                }} className="d-flex mt-2">
                  <Input type="text" value={newMessage} onChange={(e) => setNewMessage(e.target.value)} placeholder="Type a message..." />
                  <Button type="submit" color="primary" className="ms-2">Send</Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      {/* </Container> */}
    </Fragment>
  );
};

export default DocumentList;
